(function () {
  function placeAddonsSection() {
    var panel = document.getElementById('cdp-addons-panel');
    if (!panel || panel.classList.contains('cdp-addons-section')) return;

    var priceContent = document.querySelector('.products_details_price_and_content');
    var productView = panel.closest('.productView') || document.querySelector('.productView-container');
    var reserve = document.getElementById('book-me-container');
    var highlights = document.getElementById('highlights-section');
    var btnWrap = document.querySelector('.BTN_with_calendar');

    var reserveMarker = document.createComment('reserve-position');
    var highlightsAfterRow = document.createComment('highlights-after-row');

    if (reserve && reserve.parentNode) reserve.parentNode.insertBefore(reserveMarker, reserve);
    if (priceContent && priceContent.parentNode) {
      priceContent.parentNode.insertBefore(highlightsAfterRow, priceContent.nextSibling);
    }

    panel.classList.add('cdp-addons-section');
    var title = panel.querySelector('.cdp-addons-title');
    if (title) title.textContent = 'Add-ons';

    // Keep add-ons panel full-width after the price + calendar row
    var container = document.querySelector('.productView-container');
    if (priceContent) {
      priceContent.insertAdjacentElement('afterend', panel);
    } else if (container) {
      container.appendChild(panel);
    } else if (productView) {
      productView.insertAdjacentElement('afterend', panel);
    }

    function syncLayout() {
      var hasAddons = panel.classList.contains('is-visible');
      var anchor = panel;

      if (hasAddons) {
        if (reserve) {
          reserve.classList.add('cdp-reserve-after-addons');
          panel.insertAdjacentElement('afterend', reserve);
          anchor = reserve;
        }
        if (highlights) {
          highlights.classList.add('cdp-highlights-after-addons');
          highlights.classList.remove('cdp-highlights-below-booking');
          anchor.insertAdjacentElement('afterend', highlights);
        }
      } else {
        // No add-ons: Reserve stays under the calendar in its normal place
        if (reserve) {
          reserve.classList.remove('cdp-reserve-after-addons');
          if (reserveMarker.parentNode) {
            reserveMarker.parentNode.insertBefore(reserve, reserveMarker.nextSibling);
          } else if (btnWrap) {
            btnWrap.appendChild(reserve);
          }
        }

        // Highlights go below the booking row so they don't stretch the left column
        // or overlap Recommended for You
        if (highlights) {
          highlights.classList.remove('cdp-highlights-after-addons');
          highlights.classList.add('cdp-highlights-below-booking');
          if (priceContent && priceContent.parentNode) {
            // Order: priceContent -> highlights -> hidden panel
            priceContent.insertAdjacentElement('afterend', highlights);
            highlights.insertAdjacentElement('afterend', panel);
          } else if (highlightsAfterRow.parentNode) {
            highlightsAfterRow.parentNode.insertBefore(highlights, highlightsAfterRow.nextSibling);
          }
        }
      }
    }

    new MutationObserver(syncLayout).observe(panel, { attributes: true, attributeFilter: ['class'] });
    syncLayout();
    window.syncCdpAddonsLayout = syncLayout;
  }

  function showPackageLoader() {
    var loader = document.getElementById('cdp-page-loader');
    if (!loader) return;
    loader.style.transition = 'none';
    loader.style.opacity = '1';
    loader.style.display = 'flex';
  }

  var descriptionTooltip;
  function showDescriptionTooltip(element) {
    if (descriptionTooltip) descriptionTooltip.remove();
    descriptionTooltip = document.createElement('div');
    descriptionTooltip.className = 'cdp-addon-description-tooltip';
    descriptionTooltip.textContent = element.textContent.trim();
    document.body.appendChild(descriptionTooltip);
    var rect = element.getBoundingClientRect();
    var tipRect = descriptionTooltip.getBoundingClientRect();
    var left = Math.max(12, Math.min(rect.left, window.innerWidth - tipRect.width - 12));
    var top = rect.top - tipRect.height - 9;
    if (top < 12) top = rect.bottom + 9;
    descriptionTooltip.style.left = left + 'px';
    descriptionTooltip.style.top = top + 'px';
  }

  function hideDescriptionTooltip() {
    if (descriptionTooltip) descriptionTooltip.remove();
    descriptionTooltip = null;
  }

  function selectedVariant() {
    if (typeof window.resolveSelectedVariant === 'function') return window.resolveSelectedVariant();
    var details = window.productDetails;
    if (!details || !Array.isArray(details.variants)) return null;
    var id = new URLSearchParams(location.search).get('variant');
    return details.variants.find(function (v) { return v.id == id || v.variantId == id; }) || details.variants[0];
  }

  function normalizeAddonVideoUrl(video) {
    if (!video) return '';
    if (typeof video === 'string') return video.trim();
    return String(video.url || video.src || video.videoUrl || '').trim();
  }

  function getAddonMediaItems(addon) {
    var items = [];
    var seen = {};
    var images = Array.isArray(addon.images) ? addon.images.filter(Boolean) : [];
    var videos = Array.isArray(addon.videos) ? addon.videos : [];
    var poster = images[0] || '';

    images.forEach(function (src) {
      var url = String(src || '').trim();
      if (!url || seen[url]) return;
      seen[url] = true;
      items.push({ type: 'image', src: url });
    });

    videos.forEach(function (video) {
      var url = normalizeAddonVideoUrl(video);
      if (!url || seen[url]) return;
      seen[url] = true;
      items.push({ type: 'video', src: url, poster: poster });
    });

    return items;
  }

  function openGallery(addon) {
    var mediaItems = getAddonMediaItems(addon);
    if (!mediaItems.length) return;

    var index = 0;
    var previousOverflow = document.body.style.overflow;
    var modal = document.createElement('div');
    modal.className = 'cdp-addon-gallery';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', (addon.title || 'Add-on') + ' media');
    modal.innerHTML =
      '<div class="cdp-addon-gallery__dialog">' +
        '<div class="cdp-addon-gallery__header">' +
          '<div><strong class="cdp-addon-gallery__title"></strong><span class="cdp-addon-gallery__counter"></span></div>' +
          '<button type="button" class="cdp-addon-gallery__close" aria-label="Close gallery">&times;</button>' +
        '</div>' +
        '<div class="cdp-addon-gallery__stage">' +
          '<button type="button" class="cdp-addon-gallery__arrow cdp-addon-gallery__prev" aria-label="Previous media">&#8249;</button>' +
          '<div class="cdp-addon-gallery__media"></div>' +
          '<button type="button" class="cdp-addon-gallery__arrow cdp-addon-gallery__next" aria-label="Next media">&#8250;</button>' +
        '</div>' +
        '<div class="cdp-addon-gallery__thumbs"></div>' +
      '</div>';

    var mediaHost = modal.querySelector('.cdp-addon-gallery__media');
    var counter = modal.querySelector('.cdp-addon-gallery__counter');
    var thumbs = modal.querySelector('.cdp-addon-gallery__thumbs');
    var prev = modal.querySelector('.cdp-addon-gallery__prev');
    var next = modal.querySelector('.cdp-addon-gallery__next');
    modal.querySelector('.cdp-addon-gallery__title').textContent = addon.title || 'Add-on media';

    mediaItems.forEach(function (item, i) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cdp-addon-gallery__thumb' + (item.type === 'video' ? ' is-video' : '');
      button.setAttribute('aria-label', 'View ' + item.type + ' ' + (i + 1));
      if (item.type === 'video') {
        var thumbVideo = document.createElement('video');
        thumbVideo.src = item.src;
        thumbVideo.muted = true;
        thumbVideo.playsInline = true;
        thumbVideo.preload = 'metadata';
        thumbVideo.setAttribute('aria-hidden', 'true');
        button.appendChild(thumbVideo);
      } else {
        var image = document.createElement('img');
        image.src = item.src;
        image.alt = '';
        image.loading = 'lazy';
        button.appendChild(image);
      }
      button.onclick = function () { index = i; render(); };
      thumbs.appendChild(button);
    });

    function stopActiveVideo() {
      var video = mediaHost.querySelector('video');
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }

    function render() {
      stopActiveVideo();
      var item = mediaItems[index];
      mediaHost.innerHTML = '';
      if (item.type === 'video') {
        var video = document.createElement('video');
        video.className = 'cdp-addon-gallery__video';
        video.src = item.src;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        mediaHost.appendChild(video);
      } else {
        var image = document.createElement('img');
        image.className = 'cdp-addon-gallery__image';
        image.src = item.src;
        image.alt = (addon.title || 'Add-on') + ' photo ' + (index + 1);
        mediaHost.appendChild(image);
      }
      counter.textContent = (index + 1) + ' / ' + mediaItems.length;
      thumbs.querySelectorAll('.cdp-addon-gallery__thumb').forEach(function (button, i) {
        button.classList.toggle('is-active', i === index);
        button.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var active = thumbs.children[index];
      if (active) active.scrollIntoView({ block: 'nearest', inline: 'center' });
    }

    function move(delta) {
      index = (index + delta + mediaItems.length) % mediaItems.length;
      render();
    }

    function close() {
      stopActiveVideo();
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
      modal.remove();
    }

    function onKey(event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    }

    prev.onclick = function () { move(-1); };
    next.onclick = function () { move(1); };
    modal.querySelector('.cdp-addon-gallery__close').onclick = close;
    modal.onclick = function (event) { if (event.target === modal) close(); };
    if (mediaItems.length === 1) {
      prev.hidden = true;
      next.hidden = true;
      thumbs.hidden = true;
    }

    var touchStart = 0;
    mediaHost.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    mediaHost.addEventListener('touchend', function (event) {
      var distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 45) move(distance > 0 ? -1 : 1);
    }, { passive: true });

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    render();
    modal.querySelector('.cdp-addon-gallery__close').focus();
  }

  placeAddonsSection();
  document.addEventListener('change', function (event) {
    var target = event.target;
    var option = target.closest("[id^='option-']");
    if (target.matches("[name='id']") || option) {
      var variantId = target.matches("[name='id']") ? target.value : (target.dataset.variantId || option.dataset.variantId);
      if (variantId) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState(history.state, '', url);
      }
      showPackageLoader();
    }
  }, true);
  window.addEventListener('productDetailsLoaded', function () {
    setTimeout(function () {
      if (typeof window.updatePerNightPrice === 'function') window.updatePerNightPrice();
      if (typeof window.displayVenueCategory === 'function') window.displayVenueCategory();
      if (typeof window.updatePaymentSummary === 'function') window.updatePaymentSummary();
      var loader = document.getElementById('cdp-page-loader');
      if (loader) {
        loader.style.transition = 'opacity .2s ease';
        loader.style.opacity = '0';
        setTimeout(function () { loader.style.display = 'none'; }, 200);
      }
    }, 0);
  });
  document.addEventListener('mouseover', function (event) {
    var description = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-desc');
    if (description) showDescriptionTooltip(description);
  });
  document.addEventListener('mouseout', function (event) {
    var description = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-desc');
    if (description && !description.contains(event.relatedTarget)) hideDescriptionTooltip();
  });
  document.addEventListener('click', function (event) {
    var media = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-media');
    if (media) {
      var card = media.closest('.cdp-addon-card');
      var variant = selectedVariant();
      var addon = variant && Array.isArray(variant.addOns)
        ? variant.addOns.find(function (item) { return String(item._id) === card.getAttribute('data-addon-id'); })
        : null;
      if (addon && getAddonMediaItems(addon).length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openGallery(addon);
        return;
      }
    }
    var actionArea = event.target.closest && event.target.closest('.cdp-addon-standalone-btn, .cdp-addon-actions');
    if (actionArea) return;
    var addOnCard = event.target.closest && event.target.closest('#cdp-addons-list .cdp-addon-card');
    if (addOnCard && typeof window.venueDatesReadyForAddons === 'function') {
      var venueCheck = window.venueDatesReadyForAddons();
      if (!venueCheck.ok) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (typeof window.showVenueValidationMessage === 'function') {
          window.showVenueValidationMessage(venueCheck.message, 'error');
        } else if (typeof window.showNotification === 'function') {
          window.showNotification(venueCheck.message, 'error');
        }
        return;
      }
    }
  }, true);
  window.openCdpAddonGallery = openGallery;
  window.getCdpAddonMediaItems = getAddonMediaItems;
})();
